import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getLogin = (payload) => {
  return axios.post(`${process.env.API_URL}/auth/local`, payload)
}

/**
 * Function to set token for authentication in localStorage
 * @param {String} token
 * @return void
 */
export const setLogin = (token) => {
  console.log("session",this.$router.$session.exists())
  router.app.$session.setItem('token',token)
  //localStorage.setItem('session', token)
  //window.$cookies.setItem('session',token)
}

/**
 * Function to remove token in localStorage
 * @return void
 */
export const logOut = () => {
  //window.$cookies.remove('session')
  //localStorage.removeItem('session')
}

/**
 * Function to know if the user is authenticated
 * @return Boolean
 */
export const isAuthenticated = (isValid) => {
  //const token = localStorage.getItem('session')
  
  //const token = window.$cookies.get('session')
  //const token = self.$session.get('session')
  //console.log("token",token)
  //router.app.$session.get('token')
  //console.log("session",router.app.$session.exists())
  return isValid
}